export default __webpack_public_path__ + "static/media/Php6.64bb1618.svg";